import enUsTranslations from './en-US';
import ptBrTranslations from './pt-BR';

export default {
  'pt-BR': ptBrTranslations,
  'en-US': enUsTranslations,
};
